import { useState } from 'react';
import { Alert, Box, CircularProgress, Link, TextField, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MDButton from '@components/MDButton';
import { apiErrorMessage } from '@functions/api-error-message';
import { AuthService } from './service/authentication.service';
import { useAuth } from 'context/auth-context';
import { AUTH_FIELD_SX, AuthLayout } from './auth-layout';
import { environment } from 'routes/environment.router';

export const LoginScreen = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { signIn } = useAuth();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [sending, setSending] = useState(false);

    const send = async (e: React.FormEvent) => {
        e.preventDefault();

        if (sending) return;

        setError('');
        setSending(true);

        try {
            const reply = await new AuthService().login(email, password);
            const payload = reply.data.data;

            // Todo login começa na tela inicial: voltar à anterior abriria a tela de outra pessoa.
            navigate('/', { replace: true });

            signIn({
                token: payload.token,
                refreshToken: payload.refreshToken,
                userId: payload.userId,
                name: payload.name,
                email: payload.email,
                expiresAt: Date.now() + payload.expiresIn * 1000,
            });
        } catch (err) {
            // Inclui o "muitas tentativas": escondê-lo atrás de "senha inválida" faria insistir.
            setError(apiErrorMessage(err));
            setSending(false);
        }
    };

    return (
        <AuthLayout subtitle={t('auth.entrarAjuda')} onSubmit={send}>
            {error && (
                <Alert severity="error" icon={false} sx={{ py: 0.5 }}>
                    <Typography variant="caption">{error}</Typography>
                </Alert>
            )}

            <TextField
                type="email"
                label={t('auth.email')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                autoComplete="username"
                sx={AUTH_FIELD_SX}
            />

            <TextField
                type="password"
                label={t('auth.senha')}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                sx={AUTH_FIELD_SX}
            />

            <MDButton type="submit" variant="gradient" color="info" size="large" disabled={sending}>
                {sending
                    ? <CircularProgress size={18} color="inherit" />
                    : t('auth.entrar')}
            </MDButton>

            {environment.features.passwordReset && (
                <Box sx={{ textAlign: 'center' }}>
                    <Link
                        component="button"
                        type="button"
                        onClick={() => navigate('/esqueci-senha', { state: { email } })}
                        sx={{ color: 'rgba(255,255,255,0.75)', fontSize: 13 }}
                    >
                        {t('auth.esqueciSenha')}
                    </Link>
                </Box>
            )}
        </AuthLayout>
    );
};
